export const useToTop = () => {
  const showScrollToTop = ref(false);
  const route = useRoute();

  const toTopClick = () => {
    if (route.name === 'product') {
      const addToCartButton = document.getElementById('product__add-to-cart-btn');
      addToCartButton?.scrollIntoView({
        block: 'end',
        behavior: 'smooth',
      });

      return;
    }

    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  };

  const checkScrollToBottomVisibility = () => {
    showScrollToTop.value = window.scrollY > window.innerHeight;
  };

  onMounted(async () => {
    checkScrollToBottomVisibility();
    window.addEventListener('scroll', checkScrollToBottomVisibility);
  });

  onUnmounted(() => {
    window.removeEventListener('scroll', checkScrollToBottomVisibility);
  });

  return {
    toTopClick,
    showScrollToTop: computed(() => showScrollToTop.value),
  };
};
